import React from "react";
import StepZilla from "react-stepzilla";
import InvitePersonalInfo from "./Steps/InvitePersonalInfo";
import InviteCompanyInfo from "./Steps/InviteCompanyInfo";
import InviteSubscriptionInfo from "./Steps/InviteSubscriptionInfo";
import InviteReview from "./Steps/InviteReview";
import { Close } from "@material-ui/icons";
import { Link } from "react-router-dom";
import $ from "jquery";
import { connect } from "react-redux";
import {
  inviteAgentAction,
  inviteAgentWithoutPlanAction,
} from "./../../actions/UserActions";
import { getAddressFromZipcodeAction } from "./../../actions/commonActions";
import {
  getToday,
  removeDashFromMobile,
  toastMessage,
} from "./../Common/Common";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
// import { getAllSubscriptionAction } from "./../../actions/SubscriptionAction";
import { getHearAboutUsAction } from "./../../actions/HearAboutUsActions";

var date = getToday();

class InviteAgent extends React.Component {
  defaultState = {
    usertype: message.ACCTOWNER,
    firstname: "",
    lastname: "",
    email: "",
    recoveryEmail: "",
    mobileNumber: "",
    otherNumber: "",
    // brokerLicenseNo: "",
    // licenseExpirationDate: date,
    // agentLicenseExpirationDate: date,
    knowAboutUs: "",
    companyInformation: {
      name: "",
      website: "",
      address: "",
      zipcode: "",
      city: "",
      state: "",
      phoneNumber: "",
      // faxNumber: "",
      // typeOfBusiness: "",
      // companySize: "",
    },
    address: "",
    bio: "-",
    jobTitle: "",
    quote: "",
    avatar: "-",
    socialMediaHandles: {
      facebook: "",
      twitter: "",
      instagram: "",
      realtor: "",
      zillow: "",
    },
    education: [],
    certifications: [],
    awards: [],
    // agentPercent: 100.0,
    // brokerPercent: 0.0,
    monthData: [],
    yearData: [],
    price: "",
    productName: "",
    amount: "",
    interval: "",
  };

  constructor(props) {
    super(props);
    this.state = this.defaultState;
  }

  componentDidMount() {
    this.props.getHearAboutUsAction();
  }

  getUserData() {
    return this.state;
  }

  updateUserData(key, value) {
    this.setState({
      [key]: value,
    });
  }

  updateUserCmpnyData(key, value) {
    this.state.companyInformation[key] = value;
  }
  componentWillMount() {
    // localStorage.removeItem("interval");
    // this.props.getAllSubscriptionAction("month").then((monthRes) => {
    //   if (monthRes.status === code.OK) {
    //     this.setState({ monthData: monthRes.data });
    //   }
    // });
    // this.props.getAllSubscriptionAction("year").then((yearRes) => {
    //   if (yearRes.status === code.OK) {
    //     this.setState({ yearData: yearRes.data });
    //   }
    // });
  }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  /**
   * @desc get steps and set button text
   * @param {*} step
   */
  getLastStep(step) {
    // if (localStorage.getItem(code.IS_STRIPE_ENABLED) === "true") {
    //   if (step === 0 || step === 1 || step === 2) {
    //     $(".saveBtn").html("Next");
    //   }
    //   if (step === 3) {
    //     $(".saveBtn").html("Confirm & Save");
    //     if (this.state.price === "") {
    //       toastMessage(code.ERROR, message.SELECT_YOUR_PLAN);
    //       $("#prev-button").trigger("click");
    //     }
    //   }
    //   if (step === 4) {
    //     this.submitAction();
    //   }
    // } else {
    //   if (step === 0 || step === 1) {
    //     $(".saveBtn").html("Next");
    //   }
    //   if (step === 2) {
    //     $(".saveBtn").html("Confirm & Register");
    //   }
    //   if (step === 3) {
    //     this.submitAction();
    //   }
    // }
    // console.log("step", step);
    if (step === 0 || step === 1) {
      $(".saveBtn").html("Next");
    }
    if (step === 2) {
      $(".saveBtn").html("Confirm & Register");
    }
    if (step === 3) {
      this.submitAction();
    }
  }

  /**
   * @desc call api on submit event for adding new buyer agent
   */
  submitAction() {
    let data = this.state;
    delete data.recoveryEmail;
    delete data.productName;
    delete data.amount;
    delete data.interval;
    delete data.monthData;
    delete data.yearData;
    data.mobileNumber = removeDashFromMobile(data.mobileNumber);
    data.otherNumber = removeDashFromMobile(data.otherNumber);
    data.companyInformation.phoneNumber = removeDashFromMobile(
      data.companyInformation.phoneNumber
    );

    // if (data.companyInformation.faxNumber) {
    //   data.companyInformation.faxNumber = removeDashFromMobile(
    //     data.companyInformation.faxNumber
    //   );
    // }

    // data.agentPercentage = data.agentPercent;
    // data.brokerPercentage = data.brokerPercent;

    data.email = data.email.toLowerCase();

    // delete data.agentPercent;
    // delete data.brokerPercent;
    // if (localStorage.getItem(code.IS_STRIPE_ENABLED) === "true") {
    //   this.props.inviteAgentAction(data).then((res) => {
    //     this.setState(this.defaultState);
    //   });
    // } else {
    //   delete data.price;
    //   this.props.inviteAgentWithoutPlanAction(data).then((res) => {
    //     this.setState(this.defaultState);
    //   });
    // }

    delete data.price;
    this.props.inviteAgentWithoutPlanAction(data).then((res) => {
      // this.setState(this.defaultState);
      this.props.history.push({
        pathname: "/PendingProfiles",
      });
    });
  }

  render() {
    // $("#next-button").attr("tabIndex", -1);

    // const steps =
    //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
    //     ? [
    //         {
    //           name: "Personal Info",
    //           component: (
    //             <InvitePersonalInfo
    //               getUserData={() => this.getUserData()}
    //               updateUserData={(k, v) => {
    //                 this.updateUserData(k, v);
    //               }}
    //               hearAboutUs={this.props.hearAboutUs}
    //             />
    //           ),
    //         },
    //         {
    //           name: "Company Info",
    //           component: (
    //             <InviteCompanyInfo
    //               getUserData={() => this.getUserData()}
    //               updateUserDetails={(k, v) => {
    //                 this.updateUserData(k, v);
    //               }}
    //               updateUserData={(k, v) => {
    //                 this.updateUserCmpnyData(k, v);
    //               }}
    //               getCityState={(zip) =>
    //                 this.props.getAddressFromZipcodeAction(zip)
    //               }
    //             />
    //           ),
    //         },
    //         {
    //           name: "Plan Info",
    //           component: (
    //             <InviteSubscriptionInfo
    //               getUserData={() => this.getUserData()}
    //               monthData={this.state.monthData}
    //               yearData={this.state.yearData}
    //               updateUserData={(k, v) => {
    //                 this.updateUserData(k, v);
    //               }}
    //             />
    //           ),
    //         },
    //         {
    //           name: "Review",
    //           component: (
    //             <InviteReview getUserData={() => this.getUserData()} />
    //           ),
    //         },
    //       ]
    //     : [
    //         {
    //           name: "Personal Info",
    //           component: (
    //             <InvitePersonalInfo
    //               getUserData={() => this.getUserData()}
    //               updateUserData={(k, v) => {
    //                 this.updateUserData(k, v);
    //               }}
    //             />
    //           ),
    //         },
    //         {
    //           name: "Company Info",
    //           component: (
    //             <InviteCompanyInfo
    //               getUserData={() => this.getUserData()}
    //               updateUserDetails={(k, v) => {
    //                 this.updateUserData(k, v);
    //               }}
    //               updateUserData={(k, v) => {
    //                 this.updateUserCmpnyData(k, v);
    //               }}
    //               getCityState={(zip) =>
    //                 this.props.getAddressFromZipcodeAction(zip)
    //               }
    //             />
    //           ),
    //         },
    //         {
    //           name: "Review",
    //           component: (
    //             <InviteReview getUserData={() => this.getUserData()} />
    //           ),
    //         },
    //       ];

    const steps = [
      {
        name: "Personal Info",
        component: (
          <InvitePersonalInfo
            getUserData={() => this.getUserData()}
            updateUserData={(k, v) => {
              this.updateUserData(k, v);
            }}
            hearAboutUs={this.props.hearAboutUs}
          />
        ),
      },
      {
        name: "Studio Info",
        component: (
          <InviteCompanyInfo
            getUserData={() => this.getUserData()}
            updateUserDetails={(k, v) => {
              this.updateUserData(k, v);
            }}
            updateUserData={(k, v) => {
              this.updateUserCmpnyData(k, v);
            }}
            getCityState={(zip) => this.props.getAddressFromZipcodeAction(zip)}
          />
        ),
      },
      {
        name: "Review",
        component: <InviteReview getUserData={() => this.getUserData()} />,
      },
    ];

    // if (this.props.checkStatus) {
    //   this.props.history.push("/buyeragent");
    // }

    return (
      <div className="reg-page agent-create">
        <div className="loginBg">
          <div className="step-progress">
            <div className="reg-title-wrapper">
              <h4 className="title-big mt-0 pt-2">
                Create Studio Owner Account
              </h4>
              <Link
                to="/AccountOwner"
                className="nav-link p-0 color-black close-link"
              >
                <Close
                  style={{ stroke: "#fff", height: "40px", width: "40px" }}
                />
              </Link>
            </div>
            <div className="multi-step multi-step-register">
              <StepZilla
                steps={steps}
                showNavigation={true}
                backButtonCls="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
                nextButtonCls="btn btn-sm btn-primary btn-blue w-140 saveBtn dsdsdsd"
                onStepChange={(step) => this.getLastStep(step)}
                hocValidationAppliedTo={[0, 1]}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    checkStatus: state.reducer.checkStatus,
    invieAgentMsg: state.reducer.invieAgentMsg,
    hearAboutUs: state.reducer.hearAboutUs,
  };
};

export default connect(
  mapStateToProps,
  {
    inviteAgentAction,
    getAddressFromZipcodeAction,
    // getAllSubscriptionAction,
    inviteAgentWithoutPlanAction,
    getHearAboutUsAction,
  }
)(InviteAgent);
